import { useMutation } from "@tanstack/react-query";
import { ssoApi } from "@repo/api";

export const useRefreshMetadata = () => {
  return useMutation({
    mutationFn: () => ssoApi.refreshMetadata(),
  });
};
